import React from "react";
import { motion } from "framer-motion";
import "./ProductSlider.css";

import "../pages/Home.css";

// 10 Products using your assets
import s1 from "../assets/services-1.jpg";
import s2 from "../assets/services-2.jpg";
import s3 from "../assets/services-3.jpg";
import s4 from "../assets/services-4.jpg";
import s5 from "../assets/services-5.jpg";
import s6 from "../assets/services-6.jpg";
import s7 from "../assets/services-7.jpg";
import s8 from "../assets/services-8.jpg";
import s9 from "../assets/services-9.jpg";
import s10 from "../assets/services-10.jpg";

const products = [
  { id: "01", name: "Transformer Oil Pump", model: "High-Temp Series", img: s1 },
  { id: "02", name: "Glandless Pump", model: "Maintenance Free", img: s2 },
  { id: "03", name: "Monoblock Pump", model: "Self-Priming Tech", img: s3 },
  { id: "04", name: "Canned Motor Pump", model: "Sealless Design", img: s4 },
  { id: "05", name: "Marine Centrifugal", model: "Corrosion Proof", img: s5 },
  { id: "06", name: "Chemical Process", model: "Industrial Grade", img: s6 },
  { id: "07", name: "Custom Engineered", model: "Special Application", img: s7 },
  { id: "08", name: "Heavy Duty Pump", model: "Traction Power", img: s8 },
  { id: "09", name: "Cooling System", model: "Efficient Flow", img: s9 },
  { id: "10", name: "Process Solution", model: "Precision Flow", img: s10 },
];

const ProductSlider = () => {
  const doubleProducts = [...products, ...products];

  return (
    <section className="kinetic-section">
      {/* Moving Background Grid */}
      <div className="blueprint-overlay"></div>

     <div className="exact-header">
  {/* <div className="exact-system">
    SYSTEM STATUS: OPERATIONAL
  </div> */}

  <h1 className="exact-title">
    ADVANCED <span>PUMPING</span> SOLUTIONS
  </h1>
</div>

      <div className="infinite-marquee">
        <motion.div 
          className="marquee-inner"
          animate={{ x: [0, -2500] }}
          transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
        >
          {doubleProducts.map((item, idx) => (
            <div className="kinetic-card" key={idx}>
              <div className="card-glare"></div>
              <div className="card-id">{item.id}</div>
              
              <div className="img-container">
                <img src={item.img} alt={item.name} />
              </div>

              <div className="card-content">
                <h3>{item.name}</h3>
                <p className="model-code">{item.model}</p>
                <div className="blueprint-line"></div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProductSlider;